jQuery(function($){
  var swiper = new Swiper('.work-slider', {
    slidesPerView: 1,
    spaceBetween: 14,
    loop: true,
    navigation: {
      prevEl: '.work-slider__prev-button',
      nextEl: '.work-slider__next-button'
    }
  });
});
